module.exports = __webpack_public_path__ + "img/folhaListrada.a6d4c1ce.svg";